import React, { Component } from 'react'
import { Row, Col, Button, Popconfirm, Upload, Icon, Input, Spin } from 'antd'
import { app, api, config } from "../../app"
import FormModal from "../../components/FormModal2"
import BraftEditor from 'braft-editor'
import { ContentUtils } from 'braft-utils'


/**
 * 上传之前2
 * @param file
 */
function beforeUpload2 (file) {
    const isLt2M = file.size / 1024 / 1024 < 2, types = ['image/png', 'image/jpeg', 'image/gif', 'image/webp']
    if (!isLt2M) {
        app.alert('图片最大2MB！', 'error')
        return Promise.reject(false)
    } else if (types.indexOf(file.type) === -1) {
        app.alert('仅支持上传【.png, .jpg, .gif】！', 'error')
        return Promise.reject(false)
    }

    return Promise.resolve(true)
}

class BottomNavigation extends Component {
    constructor (props) {
        super(props)
        this.state = {
            dataList: [],
            select_bn: {},
            edit_bn: {},
            dl_loading: false,
            submit_loading: false,
            edit_visible: false,
            has_content: 0
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.handleDataList()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    /**
     * 数据列表
     * @returns {Promise<void>}
     */
    handleDataList = async () => {
        await this.setData({ dl_loading: true })
        let { flag, data, msg } = await app.post(api.BottomMenuAdminLists, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        })
        let select_bn = {}
        if (flag !== 1) {
            data = []
            app.alert(msg, "error")
        } else {
            select_bn = data[0] || {}
        }
        await this.setData({ dl_loading: false, dataList: data, select_bn })
    }

    /**
     * 选择导航
     * @param select_bn
     * @returns {Promise<void>}
     */
    handleSelBN = async (select_bn) => {
        await this.setData({ select_bn })
    }

    setData = (data) => app.setStateSync(this, data)

    handleCloseEditModal = () => {
        this.setData({ edit_visible: false, has_content: 0, edit_bn: {} })
    }
    handleOpenEditModal = (has_content, edit_bn = {}) => {
        this.setData({ edit_visible: true, has_content, edit_bn })
    }

    /**
     * 提交修改
     */
    handleEdit = async (id, name, content) => {
        let params = {
            id,
            name,
            content,
            indexno: app.getData('indexno'),
            account: app.getData('account')
        }
        let { flag, msg } = await app.post(api.BottomMenuAdminEdit, params)
        if (flag === 1) {
            app.alert('修改成功', 'success')
            return true
        } else {
            app.alert(msg, 'error')
            return false
        }
    }

    /**
     * 提交添加
     */
    handleAdd = async (name, content, pid = 0) => {
        let params = {
            pid,
            name,
            content,
            indexno: app.getData('indexno'),
            account: app.getData('account')
        }
        let { flag, msg } = await app.post(api.BottomMenuAdminAdd, params)
        if (flag === 1) {
            app.alert('添加成功', 'success')
            return true
        } else {
            app.alert(msg, 'error')
            return false
        }
    }

    /**
     * 提交删除
     */
    handleDel = async (id) => {
        let params = {
            id,
            indexno: app.getData('indexno'),
            account: app.getData('account')
        }
        let { flag, msg } = await app.post(api.BottomMenuAdminDelete, params)
        if (flag === 1) {
            app.alert('删除成功', 'success')
            await this.handleDataList()
        } else {
            app.alert(msg, 'error')
        }
    }

    /**
     * 提交
     * @param name
     * @param content
     * @returns {Promise<boolean>}
     */
    handleSubmit = async ({ name, content }) => {
        if (this.state.submit_loading) return false
        let { select_bn, edit_bn, has_content} = this.state
        await this.setData({ submit_loading: true })
        let flag = false
        let html = has_content && content ? content.toHTML() : ''
        if (edit_bn.id) {
            flag = await this.handleEdit(edit_bn.id, name, html)
        } else {
            flag = await this.handleAdd(name, html, has_content ? select_bn.id : 0)
        }
        await this.setData({ submit_loading: false })
        if (flag) {
            await this.handleCloseEditModal()
            await this.handleDataList()
        }
    }

    /**
     * 编辑器图片上传
     * @param file
     * @returns {boolean}
     */
    editorUploadHandler = ({ file }) => {
        if (!file) {
            return false
        }
        if (file.status === 'done' && file.response && file.response.flag === 1) {
            this.edit_ref.setFieldsValue({
                content: ContentUtils.insertMedias(this.edit_ref.getFieldValue('content'), [{
                    type: 'IMAGE',
                    url: config.imgUrl + file.response.data.url
                }])
            })
        } else if (file.status === 'error') {
            app.alert('上传失败', 'error')
        }
    }

    onEditRef = (ref) => {
        this.edit_ref = ref
    }

    render () {
        const excludeControls = ['media', 'emoji', 'code'], extendControls = [
            {
                key: 'antd-uploader',
                type: 'component',
                component: (
                    <Upload
                        accept="image/png,image/jpeg,image/gif"
                        showUploadList={false}
                        action={config.serverUrl + api.ImageUpload}
                        beforeUpload={beforeUpload2}
                        data={{
                            token: app.getData('token'),
                            indexno: app.getData('indexno'),
                            account: app.getData('account'),
                            upload_type: 'bottom_menu'
                        }}
                        name="image"
                        multiple={true}
                        onChange={(file) => this.editorUploadHandler(file)}
                    >
                        {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
                        <button type="button" className="control-item button upload-button" data-title="插入图片">
                            <Icon type="picture" theme="filled"/>
                        </button>
                    </Upload>
                )
            }
        ]
        let { dataList, select_bn, edit_visible, edit_bn, dl_loading, submit_loading, has_content } = this.state,
            formItemLayout = {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 4 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 16 },
                }
            },
            formItems = [
                {
                    formItemLayout,
                    label: "名称",
                    name: "name",
                    options: {
                        rules: [
                            { required: true, message: '请填写名称' },
                        ], initialValue: edit_bn.id ? edit_bn.name : ''
                    },
                    component: (
                        <Input/>
                    )
                },
            ]
        if (edit_visible && has_content) {
            formItems.push({
                formItemLayout,
                label: "内容",
                name: "content",
                options: {
                    trigger: 'onBlur',
                    rules: [
                        {
                            required: true,
                            validator: (_, value, callback) => {
                                if (value.isEmpty()) {
                                    callback('请输入新闻内容')
                                } else {
                                    callback()
                                }
                            }
                        },
                    ], initialValue: BraftEditor.createEditorState(edit_bn.id ? edit_bn.content : null)
                },
                component: (
                    <BraftEditor
                        style={{ border: '1px solid #eee' }}
                        excludeControls={excludeControls}
                        extendControls={extendControls}
                        stripPastedStyles={true}
                        placeholder="请输入新闻内容"
                    />
                )
            })
        }
        return (
            <div className="bottom-navigation">
                <div className="page-title">底部导航设定</div>
                {
                    dl_loading ? <div style={{ textAlign: 'center' }}><Spin size="large"/></div> :
                        <div className="page-content">
                            <div className="bn-item">
                                <Row type="flex" justify="space-between" align="middle">
                                    <span className="bni-title">类别标题</span>
                                    <Button onClick={() => this.handleOpenEditModal(0)}>添加导航</Button>
                                </Row>
                                <div className="bno-items">
                                    {
                                        dataList.map((dl, i) => {
                                            return (
                                                <div
                                                    className={["bnoi", dl.id === select_bn.id ? 'bnoi-sel' : ''].join(' ')}
                                                    key={i} onClick={() => this.handleSelBN(dl)}>
                                                    <span className="bnoi-name"
                                                          style={{ marginRight: '1rem' }}>{dl.name}</span>
                                                    <span className="link" style={{ marginRight: '.5rem' }}
                                                          onClick={() => this.handleOpenEditModal(0, dl)}>编辑</span>
                                                    <Popconfirm title="确定删除" onConfirm={() => this.handleDel(dl.id)}>
                                                        <span className="link">删除</span>
                                                    </Popconfirm>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            <div className="bn-item">
                                <Row type="flex" justify="space-between" align="middle">
                                    <span className="bni-title">{select_bn.name}</span>
                                    <Button onClick={() => this.handleOpenEditModal(1)}>添加导航</Button>
                                </Row>
                                <div className="bno-items">
                                    {
                                        (select_bn.child || []).map((dl, i) => {
                                            return (
                                                <div
                                                    className={["bnoi", dl.id === select_bn.id ? 'bnoi-sel' : ''].join(' ')}
                                                    key={i}>
                                                    <span className="bnoi-name">{dl.name}</span>
                                                    <span className="link" style={{ margin: '0 20px' }}
                                                          onClick={() => this.handleOpenEditModal(1, dl)}>编辑</span>
                                                    <Popconfirm title="确定删除" onConfirm={() => this.handleDel(dl.id)}>
                                                        <span className="link">删除</span>
                                                    </Popconfirm>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                }
                <FormModal
                    modal={{
                        visible: edit_visible,
                        title: select_bn ? '编辑导航' : '添加导航',
                        onCancel: this.handleCloseEditModal,
                        okText: "确认",
                        cancelText: "取消",
                        confirmLoading: submit_loading,
                        maskClosable: false,
                        destroyOnClose: true,
                        width: '80%',
                        centered: true
                    }}
                    onSubmit={this.handleSubmit}
                    onRef={this.onEditRef}
                >{formItems}</FormModal>
            </div>
        )
    }
}

export default BottomNavigation



// WEBPACK FOOTER //
// ./src/routes/grade/BottomNavigation.jsx